import { formatIs, rankWith } from "@jsonforms/core";

export default rankWith(4, formatIs("options"));
